module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/sorority-social-image-e331490da4fabfb579a7db92e979a512.jpg";